<template>
  <div class="min-h-screen bg-gray-100">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="姿态检测"
      left-arrow
      @click-left="$router.back()"
    />

    <!-- 3D模型展示区域 -->
    <div class="bg-white p-4">
      <div ref="modelContainer" class="w-full h-64 bg-gray-900 rounded-lg"></div>
      <div class="mt-4 flex justify-between items-center">
        <div class="text-sm">
          <span class="text-gray-500">当前姿态：</span>
          <span class="text-primary font-medium">{{ currentPose }}</span>
        </div>
        <van-button 
          type="primary" 
          size="small"
          :loading="isRecording"
          @click="toggleRecording"
        >
          {{ isRecording ? '停止记录' : '开始记录' }}
        </van-button>
      </div>
    </div>

    <!-- 历史记录 -->
    <div class="mt-4 bg-white p-4">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium">历史记录</h3>
        <van-dropdown-menu>
          <van-dropdown-item v-model="timeRange" :options="timeRangeOptions" />
        </van-dropdown-menu>
      </div>
      
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div 
          v-for="(record, index) in records" 
          :key="index"
          class="border-b border-gray-200 py-3"
        >
          <div class="flex justify-between items-center">
            <div>
              <p class="font-medium">{{ record.pose }}</p>
              <p class="text-sm text-gray-500">{{ record.duration }}分钟</p>
            </div>
            <p class="text-sm text-gray-500">{{ formatDate(record.timestamp) }}</p>
          </div>
          <div class="mt-2">
            <van-progress 
              :percentage="record.accuracy" 
              :pivot-text="record.accuracy + '%'"
              color="#38B2AC"
            />
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'PoseDetection',
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      model: null,
      currentPose: '站立',
      isRecording: false,
      timeRange: 0,
      timeRangeOptions: [
        { text: '今天', value: 0 },
        { text: '本周', value: 1 },
        { text: '本月', value: 2 }
      ],
      loading: false,
      finished: false,
      records: [],
      page: 1
    }
  },
  computed: {
    ...mapGetters(['currentDevice'])
  },
  methods: {
    formatDate,
    initThreeJS() {
      // 移除实际逻辑，保留方法
      console.log('initThreeJS 方法被调用')
    },
    animate() {
      // 简化逻辑
      console.log('animate 方法被调用')
    },
    async loadModel() {
      // 移除实际逻辑，保留方法
      console.log('loadModel 方法被调用')
    },
    toggleRecording() {
      // 简化逻辑
      this.isRecording = !this.isRecording
      console.log('toggleRecording 方法被调用, 状态:', this.isRecording)
    },
    startRecording() {
      // 移除实际逻辑，保留方法
      console.log('startRecording 方法被调用')
    },
    stopRecording() {
      // 移除实际逻辑，保留方法
      console.log('stopRecording 方法被调用')
    },
    async onLoad() {
      // 移除实际逻辑，保留方法
      console.log('onLoad 方法被调用')
      // 添加模拟数据
      this.records.push(
        {
          pose: '站立',
          duration: 25,
          accuracy: 95,
          timestamp: Date.now()
        },
        {
          pose: '行走',
          duration: 15,
          accuracy: 88,
          timestamp: Date.now() - 3600000
        }
      )
      this.loading = false
      this.finished = true
    }
  },
  mounted() {
    // 移除实际逻辑，保留基本结构
    console.log('PoseDetection 页面已挂载')
  },
  beforeDestroy() {
    // 简化逻辑
    console.log('PoseDetection 页面即将销毁')
  },
  watch: {
    timeRange() {
      // 简化逻辑
      this.records = []
      this.page = 1
      this.finished = false
      console.log('timeRange 变更，重新加载数据')
    }
  }
}
</script>

<style scoped>
.van-dropdown-menu {
  height: 30px;
}
</style> 